import { getApiGalaxyServer } from 'services';

/**
 * Response shape from galaxy-server `GET /lookup/integration-counts`.
 * Keys are targetService strings (e.g. "deltek-ajera-cloud"), values are the
 * number of ACTIVE integrations aggregated across all tenants/realms.
 */
export type IntegrationCountsResponse = Record<string, number>;

export const getIntegrationCountsApi = ({ token, config = {} }: BaseApiParams<void>) => {
  return getApiGalaxyServer<IntegrationCountsResponse>(`/lookup/integration-counts`, config, token);
};
